import { useDataSubmit } from 'Simple/Data.js'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'note_template',
    viewPath: props.viewPath,
  })

  return function onSubmit() {
    return submit({ type: 'edit' })
  }
}
